import React from 'react';
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from '@emotion/styled'
import { useStaticQuery, graphql } from "gatsby"
import { useLocalization } from 'gatsby-theme-i18n';

const Logo = (props) => {
  let { theme } = props; 
  let { t } = useLocalization();

  const data = useStaticQuery(graphql`
    query Logo {
      event_logo_dark : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "layout/logo_event.png"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      event_logo_light : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "layout/logo_event_light.png"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
    }
  `);

  return(
    <LogoWrapper className={theme} {...props}>
      <GatsbyImage image={theme === "dark" ? getImage(data.event_logo_dark) : getImage(data.event_logo_light)} alt={t('event.logo.title')} />
    </LogoWrapper>
  );

}

const LogoWrapper = styled.div`
  width:100%;
  max-width:368px;
  margin:0 auto;
`

export default Logo;
